const getters = {
    getPoolsOfCandidateId: (state) => (candidateId) => {
        return _.filter(state.pools, { 'candidateId': candidateId});
    },
    getPoolsOfCustomerId: (state) => (customerId) => {
        return _.filter(state.pools, { 'customerId': customerId});
    },
    getPools: (state) => {
        return _.toArray(state.pools);
    }
}

export default getters